// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\"> Repaying Your Loan </h1> ";
// Exports
export default code;